import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { PHONES } from "@/data";

export const FloatingWhatsApp = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="floating-whatsapp-menu"
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            className="w-60 rounded-[6px] border border-[#d4af37]/40 bg-[#0a0a0b]/90 p-3 backdrop-blur-xl"
          >
            <p className="px-2 pb-2 text-xs tracking-[0.2em] uppercase text-zinc-400">Escolha o número</p>
            {PHONES.map((p) => (
              <a
                key={p.id}
                data-testid={`floating-whatsapp-${p.id}`}
                href={p.wa}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 rounded-[4px] px-3 py-3 text-white transition-colors hover:bg-white/5"
              >
                <MessageCircle className="h-4 w-4 text-[#d4af37]" /> {p.label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        data-testid="floating-whatsapp-toggle"
        aria-label="Contactar por WhatsApp"
        onClick={() => setOpen((o) => !o)}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.6, type: "spring" }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="gold-bg flex h-14 w-14 items-center justify-center rounded-full text-black shadow-[0_10px_40px_-5px_rgba(212,175,55,0.6)]"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </motion.button>
    </div>
  );
};
